"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionInfo = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../../../hooks");
var _context = require("../../context");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SubscriptionInfo = ({
  onClose,
  open
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const {
    isBrandPartner,
    learnMoreLink
  } = (0, _context.useSubscriptionModule)();
  // Use different subtitles for Brand Partners
  const subtitles = (isBrandPartner ? translations.subscribeInfoSubtitlesBrandPartner : translations.subscribeInfoSubtitles).split(';').filter(Boolean);
  // Use different descriptions for Brand Partners
  const descriptions = (isBrandPartner ? translations.subscribeInfoDescriptionsBrandPartner : translations.subscribeInfoDescriptions).split(';').filter(Boolean);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Dialog, {
    open: open,
    header: translations.subscribeInfoMainTitle,
    disablePortal: false,
    onClose: onClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
      "data-testid": getTestId(_constants.SUBSCRIPTION_INFO),
      children: [subtitles.map((value, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Section, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          fontWeight: "bold",
          children: value
        }), descriptions[index] ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: descriptions[index]
        }) : null]
      }, value)), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Buttons, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          fullWidth: true,
          color: "primary",
          variant: "contained",
          onClick: onClose,
          children: translations.gotIt
        }), learnMoreLink ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
          fullWidth: true,
          color: "default",
          variant: "text",
          href: learnMoreLink,
          children: translations.learnMore
        }) : null]
      })]
    })
  });
};
exports.SubscriptionInfo = SubscriptionInfo;
